import { render, staticRenderFns } from "./ListsTournament.vue?vue&type=template&id=6b63240f&scoped=true"
import script from "./ListsTournament.vue?vue&type=script&lang=js"
export * from "./ListsTournament.vue?vue&type=script&lang=js"
import style0 from "./ListsTournament.vue?vue&type=style&index=0&id=6b63240f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b63240f",
  null
  
)

export default component.exports